import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import FsLightbox from 'fslightbox-react';
import { Element } from 'react-scroll';
import { FaPlay } from 'react-icons/fa';

const MembershipAIReadyBanner = () => {
  const [toggler, setToggler] = useState(false);
  const videoLink = ['https://www.youtube.com/embed/rxKfq5j0gHg?autoplay=1&rel=0'];

  return (
    <Element
      name="datatalent-banner"
      className="data-talent-jobseekers-banner am-banner banner-style-1 bg-image height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-6 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center">
                  <Link to="/programs">Our Programs</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  <Link to="/programs/membership">Membership</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  AIReady (Professional)
                </div>
                <h1 className="datatalent-program-title title mt-4">AIReady</h1>
                <p className="membership-description">Work on paid data science projects to gain real-world experience.</p>
                <p>During your 12-month membership, gain access to a library of courses and complete paid projects with our employer partners. Elevate your resume, increase your toolkit and expand your project portfolio!</p>
                <span className="datatalent-description-span">*includes all benefits from Skillsboost</span>
                <div className="read-more-btn banner-btns">
                  {/* <button className="edu-btn" onClick={() => setShowEmployerRegisterForm(true)}>Employer Login</button>
                  <button className="edu-btn btn-secondary" onClick={() => setShowUserInterestForm(true)}>Jobseekers Login</button> */}
                  <div className="col-6 col-lg-4">
                    <a className="edu-btn btn-primary text-center" href="https://courses.m2mtechconnect.com/enroll/3159647">Register Now</a>
                  </div>
                  <div className="col-6 col-lg-4 d-flex align-items-center justify-content-center">
                    {/* <Link className="edu-btn btn-bg-alt text-center" to="/contact-us">Contact Us</Link> */}
                    <strong>$1400 + Tax per year</strong>
                  </div>
                </div>
                <p className="student-discount mt-4 mb-0">Are you a student? Email <a href="mailto:programs@m2mtechconnect.com">programs@m2mtechconnect.com</a> for a discounted rate!</p>
                {/* <p className="datatalent-partners-header d-none d-md-block mt--40 mb-0"><strong>Partnered With</strong>:</p>
                <div className="datatalent-partners d-none d-md-flex align-items-center mt-0 mx-0">
                  <div className="col-lg-3">
                    <a className="p-0" href="https://www.canada.ca/en.html"><img src={`${process.env.PUBLIC_URL}/images/logo/govt_of_canada.svg`} alt="logo" loading="lazy" /></a>
                  </div>
                  <div className="col-lg-5">
                    <a className="p-0" href="https://paletteskills.org/upskill-canada"><img src={`${process.env.PUBLIC_URL}/images/logo/upskill_canada_logo_v3.png`} alt="logo" loading="lazy" /></a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-6 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <div className="feature-thumbnail">
              <div className="main-image video-popup-wrapper video-popup-two">
                <img src={`${process.env.PUBLIC_URL}/images/videopopup/pexels-monstera-6238170_v2.png`} alt="Video PopUp Thumb" loading="lazy" />

                <button className="video-play-btn with-animation position-to-top btn-large video-popup-activation eduvibe-video-play-icon color-secondary" onClick={ () => setToggler( ! toggler ) }><span><FaPlay className="play-icon" /></span></button>
              </div>
            </div>
            <div className="datatalent-stats-container d-flex align-items-start justify-content-center">
              <div className="col-4 datatalent-stats-courses">
                <h5 className="datatalent-stat-header">14,000+ Course Enrollments</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">80+<br></br>courses</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Join thousands of learners advancing their careers with M2M Tech</p>
              </div>
              <div className="col-4 datatalent-stats-ratings">
                <h5 className="datatalent-stat-header">1,000+ Program Graduates</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">12<br></br>Weeks</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Our graduates are excelling and making an impact in the industry</p>
              </div>
              <div className="col-4 datatalent-stats-schedule">
                <h5 className="datatalent-stat-header d-none d-md-block">300+ Courses Available</h5>
                <h5 className="datatalent-stat-header d-block d-md-none">300+<br></br> Courses Available</h5>
                {/* <h5 className="datatalent-stat-header d-block d-md-none">300+<br></br>Graduates</h5> */}
                <p className="datatalent-stat-description d-none d-md-block">Explore a wide range of courses tailored to today's workforce needs</p>
              </div>
            </div>
            {/* <div className="partners-container w-100">
              <p className="datatalent-partners-header d-block d-md-none mt--40 mb-0"><strong>Funded by</strong>:</p>
              <div className="datatalent-partners d-flex flex-wrap d-md-none align-items-center mt-3 mx-0">
                <div className="col-6">
                  <a className="p-0" href="https://www.canada.ca/en.html"><img src={`${process.env.PUBLIC_URL}/images/logo/govt_of_canada.svg`} alt="logo" loading="lazy" /></a>
                </div>
                <div className="col-12">
                  <a className="p-0" href="https://paletteskills.org/upskill-canada"><img src={`${process.env.PUBLIC_URL}/images/logo/upskill_canada_logo_v3.png`} alt="logo" loading="lazy" /></a>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="video-lightbox-wrapper">
          <FsLightbox
            toggler={ toggler } 
            sources={ [ <iframe src={videoLink} style={{"width": "960px"}} height="540px" frameBorder="0" title="Youtube video player" allow="autoplay; fullscreen" /> ] }
            maxYoutubeVideoDimensions={ { width: 960, height: 540 } }
          />
        </div>
      </div>
    </Element>
  )
}

export default MembershipAIReadyBanner;